// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact-container {
  max-width: 500px;
  margin: 50px auto;
  padding: 30px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  font-family: 'Arial', sans-serif;
}

.contact-container h2 {
  text-align: center;
  margin-bottom: 20px;
  font-size: 28px;
  color: #333;
}

.contact-container label {
  display: block;
  margin-bottom: 6px;
  font-weight: bold;
  color: #555;
}

.contact-container input,
.contact-container textarea {
  width: 100%;
  padding: 10px 12px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 16px;
  transition: all 0.3s ease;
}

.contact-container input:focus,
.contact-container textarea:focus {
  border-color: #007bff;
  box-shadow: 0 0 6px rgba(0, 123, 255, 0.3);
  outline: none;
}

.contact-container button {
  width: 100%;
  padding: 12px;
  background-color: #007bff;
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.contact-container button:hover {
  background-color: #0056b3;
}

.status-message {
  text-align: center;
  margin-bottom: 15px;
  color: green;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ContactForm.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yCAAyC;EACzC,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,qBAAqB;EACrB,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB","sourcesContent":[".contact-container {\n  max-width: 500px;\n  margin: 50px auto;\n  padding: 30px;\n  background-color: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);\n  font-family: 'Arial', sans-serif;\n}\n\n.contact-container h2 {\n  text-align: center;\n  margin-bottom: 20px;\n  font-size: 28px;\n  color: #333;\n}\n\n.contact-container label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: bold;\n  color: #555;\n}\n\n.contact-container input,\n.contact-container textarea {\n  width: 100%;\n  padding: 10px 12px;\n  margin-bottom: 15px;\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  font-size: 16px;\n  transition: all 0.3s ease;\n}\n\n.contact-container input:focus,\n.contact-container textarea:focus {\n  border-color: #007bff;\n  box-shadow: 0 0 6px rgba(0, 123, 255, 0.3);\n  outline: none;\n}\n\n.contact-container button {\n  width: 100%;\n  padding: 12px;\n  background-color: #007bff;\n  border: none;\n  border-radius: 8px;\n  color: white;\n  font-size: 18px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.contact-container button:hover {\n  background-color: #0056b3;\n}\n\n.status-message {\n  text-align: center;\n  margin-bottom: 15px;\n  color: green;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
